// context.js
import { createContext } from 'react';
const MyContext =createContext();
export const Provider = MyContext.Provider
export const Consumer = MyContext.Consumer
// Create the context
export default MyContext ;

